export default "__VITE_ASSET__b4d486d1__"